<!--  -->
<template>
  <div class="main">
    <!-- 标题  -->
    <p class="title-Individual-center">
      <span>人才资源管理</span>
      <i class="el-icon-arrow-right"></i>
      <span @click="$router.push('/Firm/talentStaff')" style="cursor: pointer"
        >员工管理</span
      >
      <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">{{ routeName }}</span>
      <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">{{ deptTree.label }}</span>
      <i class="el-icon-arrow-right" v-if="dept_2"></i>
      <span class="span-Individual-center" v-if="dept_2">{{
        dept_2.label
      }}</span>
    </p>
    <div class="box">
      <div class="left">
        <div class="flex-box2">
          <div
            class="blue-button"
            style="width: 85px; height: 25px"
            @click="JumpTo"
          >
            员工设置
          </div>
        </div>
        <div
          :class="
            isIndex == -1
              ? 'gs-name gs-name-blue overflow-text'
              : 'gs-name overflow-text'
          "
          :title="deptTree && deptTree.label ? deptTree.label : ''"
          @click="getBm"
        >
          {{ deptTree.label }}
        </div>
        <div class="department-list">
          <div
            v-for="(item, index) in deptTree.children"
            :key="index"
            class="overflow-text"
            :title="item.label || ''"
            :class="
              isIndex == index
                ? 'department-item department-item-active'
                : 'department-item'
            "
            @click="open(item, index)"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
      <div class="right">
        <div style="margin-bottom: 30px; float: right">
          <el-button
            type="primary"
            style="background-color: #409eff ; width: 120px"
            @click="onAdd"
            >添加</el-button
          >
          <el-button
            type="primary"
            style="background-color: #409eff ; width: 120px"
            @click="delDeps"
            >批量删除<span v-if="delList.length > 0"
              >（{{ delList.length }}）</span
            ></el-button
          >
        </div>
        <el-table
          row-key="id"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :row-class-name="tableRowClassName"
          :cell-style="{ 'text-align': 'center', fontSize: '12px' }"
          :header-cell-style="{
            background: '#409eff ',
            color: '#fff',
            'text-align': 'center',
            fontWeight: 300,
            fontSize: '12px',
          }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="50"> </el-table-column>
          <el-table-column prop="deptName" label="名称"> </el-table-column>
          <el-table-column prop="createTime" label="创建时间">
          </el-table-column>
          <el-table-column label="操作">
            <div style="display: flex; padding: 0 80px" slot-scope="scope">
              <el-button
                type="text"
                style="font-size: 12px"
                @click="onEdit(scope.row)"
                >编辑</el-button
              >
              <!-- <el-button type="text" style="font-size: 12px;">移动（改为序列，暂时 ）</el-button> -->
              <el-button
                type="text"
                style="color: #fe574a; font-size: 12px"
                @click="delDep(scope.row)"
                >删除</el-button
              >
            </div>
          </el-table-column>
        </el-table>
        <!-- 底部分页 -->
        <div class="paging-box">
          <div class="paging">
            <paging
              :pagingObj="pagingObj"
              @handleCurrentChange="handleCurrentChange"
            ></paging>
          </div>
        </div>
        <dialogModel
          :title="deptId ? '编辑部门' : '添加部门'"
          :visible.sync="dialogVisible"
          @handleOk="handleOk"
        >
          <div style="padding: 30px">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              label-suffix="："
              class="demo-ruleForm"
            >
              <el-form-item label="部门名称" prop="name">
                <el-input
                  v-model="ruleForm.name"
                  placeholder="请输入部门名称"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </dialogModel>
      </div>
    </div>
  </div>
</template>

<script>
import * as API from "@/assets/api/firm/firmTalent.js";
// 引入分页组件
import paging from "../../../../components/paging.vue";
export default {
  components: {
    paging,
  },
  data() {
    return {
      //分页数据
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //总数
      },
      routeName: "",
      // 企业信息
      deptTree: "",
      // 企业子部门
      childrenDept: "",
      // 部门ID
      deptId: "",
      // 父部门ID
      deptPid: "",
      isIndex: -1,
      // 添加编辑部门弹框
      dialogVisible: false,
      ruleForm: {
        name: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入部门名称", trigger: "blur" },
        ],
      },
      // 列表数据
      tableData: [],
      // 删除列表
      delList: [],
      dept_2: "",
    };
  },
  created() {
    this.routeName = this.$route.name;
    this.getDeptTree();
  },
  mounted() {},
  methods: {
    //JumpTo
    JumpTo() {
      // 获取本地权限
      let permissionCodes = localStorage.getItem("permissionCodes");
      permissionCodes = permissionCodes ? JSON.parse(permissionCodes) : [];

      // 判断是否有员工管理权限
      if (!permissionCodes.includes("company:employee:manage")) {
        this.$message.warning("权限不足，无法执行操作");
        return;
      }

      // 有权限才跳转
      this.$router.push({
        path: "/Firm/talentStaff",
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      this.getChildrenDept(this.deptPid);
    },
    // 查询公司部门树
    getDeptTree() {
      let data = {
        data: {
          companyId: this.$store.getters.getCompany.id,
        },
      };
      API.deptTree(data).then((res) => {
        this.deptTree = res.data;
        this.deptPid = res.data.id;
        this.getChildrenDept(this.deptPid);
      });
    },
    // 查询子部门列表
    getChildrenDept(id) {
      let data = {
        pageNo: this.pagingObj.currentPage,
        pageSize: this.pagingObj.pageSize,
        data: {
          companyId: this.$store.getters.getCompany.id,
          pid: id,
        },
      };
      API.childrenDept(data).then((res) => {
        this.childrenDept = res.data;
        this.tableData = this.childrenDept.list;
        this.pagingObj.totalDevice = res.data.total;
      });
    },
    // 添加
    onAdd() {
      this.deptId = "";
      this.ruleForm.name = "";
      this.dialogVisible = true;
    },
    // 编辑
    onEdit(row) {
      this.deptId = row.id;
      this.ruleForm.name = row.deptName;
      this.dialogVisible = true;
    },
    // 新增/编辑部门确认
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.deptId) {
            // 编辑
            let data = {
              data: {
                id: this.deptId,
                companyId: this.$store.getters.getCompany.id,
                deptName: this.ruleForm.name,
              },
            };
            API.editDept(data).then((res) => {
              this.$tool.PromptBox("success", "操作成功！");
              if (this.isIndex == -1) {
                this.getDeptTree();
              } else {
                this.getChildrenDept(this.deptPid);
              }
              this.dialogVisible = false;
            });
          } else {
            let data = {
              data: {
                pid: this.deptPid,
                companyId: this.$store.getters.getCompany.id,
                deptName: this.ruleForm.name,
              },
            };
            API.addDept(data).then((res) => {
              this.$tool.PromptBox("success", "操作成功！");
              if (this.isIndex == -1) {
                this.getDeptTree();
              } else {
                this.getChildrenDept(this.deptPid);
              }
              this.dialogVisible = false;
            });
          }
        }
      });
    },
    // 勾选列表
    handleSelectionChange(val) {
      this.delList = val;
    },
    // 批量删除
    delDeps() {
      let that = this;
      if (this.delList.length > 0) {
        this.$confirmWithScroll("是否删除勾选的部门？").then(() => {
          that.batchDeleteDept(this.delList);
        });
      } else {
        that.$tool.PromptBox("error", "请至少勾选一条数据后进行操作！");
      }
    },
    // 单个删除
    delDep(row) {
      let that = this;
      this.$confirmWithScroll("是否删除该部门？").then(() => {
        that.batchDeleteDept([row]);
      });
    },
    // 删除部门
    batchDeleteDept(list) {
      let data = {
        data: {
          pid: this.deptTree.id,
          ids: list.map((item) => item.id),
          companyId: this.$store.getters.getCompany.id,
        },
      };
      API.batchDeleteDept(data).then((res) => {
        this.$tool.PromptBox("success", "操作成功！");
        this.getDeptTree();
      });
    },
    // 点击左侧某部门：展开列表；再次点击同一项则收起
    open(item, i) {
      if (this.isIndex === i) {
        this.getBm();
        return;
      }
      this.dept_2 = item;
      this.isIndex = i;
      this.deptPid = item.id;
      this.pagingObj.currentPage = 1;
      this.getChildrenDept(item.id);
    },
    // 点击企业名称：展示公司直属子部门，添加时父级须为公司根节点
    getBm() {
      this.dept_2 = "";
      this.isIndex = -1;
      if (this.deptTree && this.deptTree.id) {
        this.deptPid = this.deptTree.id;
      }
      this.pagingObj.currentPage = 1;
      this.getChildrenDept(this.deptPid);
    },
    //斑马线
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "row-style";
      }
      return "";
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-table .row-style {
  background: #eee;
}

.box {
  width: 1200px;
  min-height: 700px;
  box-sizing: border-box;
  margin-top: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(125, 125, 125, 0.5);
  border-radius: 20px;
  padding: 10px 10px;
  display: flex;

  .left {
    width: 180px;
    background: #eeeeee;
    border-radius: 10px;
    padding: 20px 10px;
    box-sizing: border-box;

    .gs-name {
      height: 40px;
      line-height: 40px;
      background: #ffffff;
      border-radius: 10px;
      font-size: 12px;
      color: #333;
      text-align: center;
      margin-top: 20px;
      cursor: pointer;
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
      padding: 0 8px;
    }

    .gs-name-blue {
      color: #409eff ;
    }

    .department-list {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;

      .department-item {
        width: 100%;
        max-width: 100%;
        font-size: 12px;
        text-align: center;
        color: #333;
        cursor: pointer;
        height: 40px;
        line-height: 40px;
        box-sizing: border-box;
        padding: 0 8px;
      }

      .department-item-active {
        color: #409eff ;
      }
    }
  }

  .right {
    width: calc(100% - 200px);
    padding: 20px;
    margin-left: 10px;
    box-sizing: border-box;

    .text-item {
      background-color: #eee;
      width: 120px;
      font-size: 12px;
      padding: 10px 5px;
      text-align: center;
      margin-right: 20px;
      border-radius: 5px;
      cursor: pointer;
    }

    .active {
      background-color: rgba(97, 144, 232, 0.2);
      color: #409eff ;
    }
  }
}

// 分页
.paging-box {
  width: 100%;
  height: 22px;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;

  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
